import React from 'react';
import {motion} from 'framer-motion';
import {Outlet, useLocation} from 'react-router-dom';
import Header from './Header';
import NotificationCenter from '../notifications/NotificationCenter';

export default function Layout() {
  const location = useLocation();
  
  return (
    <div className="flex flex-col h-screen bg-brand-bg">
      <Header />
      <main className="flex-1 overflow-y-auto">
        <motion.div 
          key={location.pathname} 
          initial={{opacity: 0, y: 10}} 
          animate={{opacity: 1, y: 0}} 
          transition={{duration: 0.3}} 
          className="h-full"
        >
          <Outlet />
        </motion.div>
      </main>
      <NotificationCenter />
    </div>
  );
}